import {
  REGIONS_LOAD_REQUEST,
  REGIONS_LOAD_SUCCESS,
  REGIONS_LOAD_FAILURE
} from '../types/regions-types';

const initialState = {
  loading: false,
  error: null,
  success: false,
  regions: []
};

function regions(state = initialState, action: any = null) {
  switch (action.type) {
    case REGIONS_LOAD_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case REGIONS_LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };

    case REGIONS_LOAD_SUCCESS:
      return {
        ...state,
        regions: action.payload,
        success: true,
        loading: false,
        error: null
      };

    default:
      return state;
  }
}

export default regions;
